var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-scratchable-wrapper"},[_vm._t("default",null,{"init":_vm.init}),_c('canvas',{on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove,"touchstart":_vm.touchDown,"touchmove":_vm.touchMove}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }